<template>
    <!-- <b-table class="mt-3" hover :items="items"></b-table> -->
    <div>
        <div class="table-div">
            <table class="table table-hover mt-5">
                <thead>
                    <tr>
                        <th>No.</th>
                        <th class="headTitle" v-for="header in tableHeaders" @click="selectSort(header.value)">{{ header.name }}</th>
                        <!-- <th class="headTitle" v-for="header in tableHeaders" @click="">{{ header.name }}</th> -->
                        <th>Details</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items">
                        <td>{{(config.currentPage-1) * config.limitPerPage + index + 1}}</td>
                        <td>{{item.rrn}}</td>
                        <td>{{item.frame_number}}</td>
                        <td>{{item.engine_number}}</td>
                        <td>{{item.from}}</td>
                        <td>{{item.to}}</td>

                        <td v-if="item.status == 'Failed'"><div class="statusStyle statusFailed text-center">{{item.status}} </div></td>
                        <td v-else><div class="statusStyle statusSuccess text-center">{{item.status}}</div></td>

                        <td>{{item.reason}}</td>
                        <td><button class="btn btn-secondary" v-on:click="showModals(item.id, item.reason)"><i class="fas fa-eye"></i></button></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <hr>
        <p v-if="meta">Showing {{1 + ((meta.currentPage - 1) * 10)}} to {{meta.currentPage != meta.lastPage ? meta.currentPage * 10 : meta.total}} of {{meta.total}} entries.</p>
        <div class="row">
            <div class="col" style="padding: 20px">
                <nav>
                    <ul class="pagination" style="justify-content:center">
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="laquo()">
                            <span class="page-link">&laquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="lsaquo()">
                            <span class="page-link">&lsaquo;</span>
                        </li>
                        <li class="page-item pageNumber" style="cursor:pointer">
                            <span class="page-link" style="color:black">
                                <span style="font-weight: bold !important">{{(config.maxPage < 1) ? 0 : config.currentPage}}</span> of {{config.maxPage}}
                            </span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="rsaquo()">
                            <span class="page-link">&rsaquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="raquo()">
                            <span class="page-link">&raquo;</span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div v-if="viewModal" >
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper" @click="viewModal = false">
                        <div class="row">
                            <div class="col-xs-1 col-sm-1 col-md-2 col-lg-4"></div>
                            <div class="col-xs-10 col-sm-10 col-md-8 col-lg-4">
                                <div class="modal-container" @click.stop>
                                    <div class="modal-body text-center">
                                        <detailLogModal :datas="detailModalData" :id="log_id" :reason="reason"></detailLogModal>
                                        <button class="btn btn-primary" v-on:click="viewModal = false">Done</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-4"></div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import detailLogModal from './detailLogModal';

export default {
    data(){
        return {
            items : [],
            detailModalData : null,
            viewModal : false,
            log_id : '',
            reason : '',
            config : {
                currentPage : 1,
                maxPage : 1,
                limitPerPage : 15,//LIMIT PER PAGE
                by : 'rrn',
                order : true,//true = ascending, false = descending, for start, Reverted
            },
            tableHeaders : [],
            tableHeaderTitles : [],
            meta : null
        }
    },
    components : {
        detailLogModal
    },
    computed:{
        orderBy(){
            return {
                by : this.config.by,
                order : (this.config.order) ? 'ASC' : 'DESC'
            }
        },
    },
    props : ['rq_uuid'],
    mounted(){
        this.addTableHeader('rrn', 'RRN')
        this.addTableHeader('frame_number', 'Frame Number')
        this.addTableHeader('engine_number', 'Engine Number')
        this.addTableHeader('from', 'From')
        this.addTableHeader('to', 'To')
        this.addTableHeader('status', 'Status')
        this.addTableHeader('reason', 'Reason')

        this.selectSort('rrn');
    },
    methods : {
        getData(){
            let url = '/api/log/list/' + this.rq_uuid;
            this.$http.get(url)
            .then((resp)=>{
                         
                this.items = resp.data.data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        showModals(log_id, reason){
            this.log_id = log_id;
            this.reason = reason;
            this.$http.get('/api/log/detail/' + log_id)
            .then((resp)=>{
                if(resp.data.code != 200)
                    throw new Error(resp.data.message)

                this.detailModalData = resp.data.data;
                this.viewModal = true;
            })
            .catch((err)=>{
                console.log(err);
                
            })
        },
        laquo(){//first page
            if(this.config.currentPage-1 > 0){
                this.fetchData(1, this.orderBy.order, this.orderBy.by);
            } else {
                this.errorPrint("First Page Reached!");
            }
        },
        lsaquo(){//previous page
            if(this.config.currentPage-1 > 0){
                this.fetchData(this.config.currentPage-1, this.orderBy.order, this.orderBy.by);
            } else {
                this.errorPrint("Last Page Reached!");
            }
        },
        rsaquo(){//next page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.currentPage+1, this.orderBy.order, this.orderBy.by);
            } else {
                this.errorPrint("Last Page Reached!");
            }
        },
        raquo(){//last page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.maxPage, this.orderBy.order, this.orderBy.by);
            } else {
                this.errorPrint("Last Page Reached!");
            }
        },
        selectSort(sortVariable){
            if(sortVariable == null){
                alert('Feature Unavailable');
                return;
            }
            if(this.config.by != sortVariable){
                this.config.by = sortVariable
                this.config.order = false
                this.fetchData(1, 'ASC', sortVariable)
            } else {
                this.config.order = !this.config.order
                if(this.config.order)
                    this.fetchData(1, 'ASC', sortVariable)
                else
                    this.fetchData(1, 'DESC', sortVariable)
            }
            this.changeSortTitle();
        },
        changeSortTitle(){
            for(var i = 0; i < this.tableHeaders.length; i++){
                if(this.config.by == this.tableHeaders[i].value){
                    if(this.config.order)
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▲'
                    else
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▼'
                } else {
                    this.tableHeaders[i].name = this.tableHeaderTitles[i]
                }
            }
        },
        addTableHeader(variable, title){
            let header = {
                value : variable,
                name : title
            }
            this.tableHeaders.push(header);
            this.tableHeaderTitles.push(title);
        },
        fetchData(page, order, by){//PAGE(1,2,3,4), ORDER(asc, desc), BY(var-name)
            var url = `/api/log/list/${this.rq_uuid}?limit=${this.config.limitPerPage}`;

            if(page)
                url = url + '&page=' + page;
            if(order)
                url = url + '&order=' + order;
            if(by)
                url = url + '&by=' + by;

            this.$http.get(url)
            .then((resp)=>{
         
                var data = resp.data.data;
                var meta = resp.data.meta;
                this.meta = meta;

                this.config.currentPage = meta.currentPage;
                // this.config.maxPage = 20;//temporary as API is being fixed
                this.config.maxPage = meta.lastPage;

                this.items = data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
    }
}
</script>


<style scoped>
    .statusFailed{
        color: #ff7152;
    }
    .statusSuccess{
        color: #68edb6;
    }
    .statusStyle{
        font-weight: bold;
    }
    th{
        text-align: center;
    }
    td{
        text-align: center;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body{
        margin:0
    }

    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a{
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }

    h3.modalHeadline{
        margin:0 0 20px 0
    }
    /* MODAL ENDS */

    .modalContent tr th{
      text-align:right;
    }

    .modalContent tr .middleDivider{
      width: 50px;
      text-align: center;
    }
    .headTitle{
        cursor: pointer;
    }
    .page-link{
        cursor: pointer;
    }
    .pageNumber .page-link:hover{
        background-color: white;
        cursor: default;
    }
    .disabled .page-link{
        background-color:#EEEEEE;
    }
    li .disabled:hover{
        cursor: default;
    }
    .table-div{
        display: block;
        overflow: scroll;
    }
</style>